import { aiApiClient } from "@src/api/ai-api";
import { knowledgeKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

const getKnowledgeRootCauses = async (source?: string): Promise<string[]> => {
  const query = source ? `?source=${encodeURIComponent(source)}` : "";
  const { data } = await aiApiClient.get<{ rootCauses: string[] }>(
    `/knowledge/documents/root-causes${query}`
  );

  return data.rootCauses;
};

export const useGetKnowledgeRootCauses = (source?: string) =>
  useQuery({
    queryKey: knowledgeKeys.rootCauses(source),
    queryFn: async () => getKnowledgeRootCauses(source),
    enabled: source === "pylon-solutions",
  });
